/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { PanelContainerComponent, PanelHeaderComponent, PanelBodyComponent } from "src/app/shared/content-panels";
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { SerialNumberDefects } from '../models/defect-history.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QBuiltInspectorDialogService } from 'src/app/qbuilt-inspector/shared/services/inspector-dialog.service';
import { DefectHistoryService } from '../services/defect-history.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-defect-detail-view',
  imports: [
    PanelContainerComponent,
    PanelHeaderComponent,
    MatIconModule,
    PanelBodyComponent,
    MatTableModule,
    MatTooltipModule
],
  templateUrl: './defect-detail-view.component.html',
  styleUrl: './defect-detail-view.component.scss',
})
export class DefectDetailViewComponent implements OnChanges, OnDestroy {
  @Input() defectViewItem: any;
  @Input() serialNumber: string = '';
  @Input() facilityNumber: string = '';
  @Output() closeDetailView = new EventEmitter<void>();

  tableColumns = [
    'Section',
    'Station',
    'TaskName',
    'Category',
    'DefectLoc',
    'DefectQuantity',
    'DefectDesc',
    'Images'
  ]

  serialData: SerialNumberDefects[] = [];
  private detailSubscription?: Subscription;
  

  constructor(private qbuiltDialog: QBuiltInspectorDialogService,
    private defectHistoryService: DefectHistoryService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['serialNumber'] || changes['defectViewItem'] || changes['facilityNumber']) {
      this.getSerialDefectData(this.serialNumber, this.defectViewItem?.HBGInspectionId, this.facilityNumber);
    }
  }

  ngOnDestroy() {
    this.detailSubscription?.unsubscribe();
  }

  getSerialDefectData(serialNumber: string, HBGInspectionId: string, facilityNumber: string) {
    this.defectHistoryService.getDefectDetails(serialNumber, HBGInspectionId, parseInt(facilityNumber));

    this.detailSubscription?.unsubscribe();
    this.detailSubscription = this.defectHistoryService.serialDefectDetails$.subscribe(data => {
      this.serialData = data;
      console.log('Serial defect data:', data);
    });
    
  }

  closePanel() {
    this.serialData = [];
    this.closeDetailView.emit();
  }

  previewPhoto(image: string) {
    console.log('Previewing photo:', image);
    //image = 'https://coenv.claytonnext.com/documents/5df664d6-ddb2-44d6-8db3-ce77dfd33a76.jpeg';
    // Implement the logic to preview the photo, e.g., open a modal or new window
    const dialogRef = this.qbuiltDialog.openInspectorDialog(6, [], undefined, image);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Preview dialog closed:', result);
    });

  }

}
